<template>
  <div class="dx-avatar">
    <img class="dx-avatar__avatar" :src="avatarPath()">
    <div class="dx-avatar__nickname" v-if="nickname">
      {{ nickname }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'dx-avatar',
  props: {
    name: String,
    nickname: String
  },
  methods: {
    avatarPath () {
      let name = this.name
      if (!this.name) {
        let random = Math.floor(Math.random() * this.all.length)
        name = this.all[random]
      }
      return require(`../assets/avatar/${name}`)
    }
  },
  computed: {
    all () {
      return [
        '002-koala.svg',
        '010-panda.svg',
        '020-giraffe.svg',
        '030-gorilla.svg',
        '033-bear.svg',
        '054-fox.svg',
        '074-octopus.svg',
        '076-rabbit.svg',
        '095-ant.svg',
        '096-ladybug.svg',
        '103-snail.svg',
        '116-wolf.svg',
        '122-owl.svg',
        '128-chicken-2.svg',
        '143-cat.svg',
        '157-pig.svg',
        '161-lion.svg',
        '162-tiger.svg',
        '165-dog.svg'
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DxAvatar.vue